import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { ViewEngineService } from 'app/infrastructure/services/viewengine.service';
import { TemplateListadoItem } from 'app/infrastructure/model/classes/templateListadoItem.class';

@Component({
    selector: 'sx-list-viewengine',
    templateUrl: './list.viewengine.component.html',
})
export class ListViewEngineComponent implements OnInit {
    codSistema: string;
    viewsEngine: Observable<TemplateListadoItem[]>;

    constructor(
        private aRoute: ActivatedRoute,
        private viewEngineService: ViewEngineService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.codSistema = params['codsistema'];
            this.viewsEngine = this.viewEngineService.getForList();
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/viewengine/list.viewengine.component.ts